'use client';

import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  showCloseBtn?: boolean;
}

const Modal = ({ isOpen, onClose, children, showCloseBtn }: ModalProps) => {
  const modalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const modalCurrent = modalRef.current;
    if (modalCurrent) {
      document.body.appendChild(modalCurrent);
      return () => {
        document.body.removeChild(modalCurrent);
      };
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  if (!modalRef.current) {
    modalRef.current = document.createElement('div');
  }

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="relative z-50 flex h-screen w-screen items-center justify-center overflow-hidden bg-white">
        {showCloseBtn && (
          <button className="absolute right-4 top-[3rem] z-50 flex p-[12px]" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} color="white" className="!h-[24px] !w-[24px]" />
          </button>
        )}
        {children}
      </div>
    </div>,
    modalRef.current
  );
};

export default Modal;
